import IconButton from './IconButton';

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/ui/IconButton/index.js